import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ChannelBundleService {
  constructor() {}

  public formatContentResources(contentList) {
    return contentList.map((content) => {
      return {
        resourceId: content.resourceId,
        resourceType: content.resourceType,
      };
    });
  }

  public formatResource(resource) {
    let resourceId: number;
    let resourceType: string;

    if (resource.referenceType) {
      resourceId = resource.referenceId;
      resourceType = resource.referenceType;
    } else if (resource.targetType) {
      resourceId = resource.targetId;
      resourceType = resource.targetType;
    } else if (resource.resourceType) {
      resourceId = resource.resourceId;
      resourceType = resource.resourceType;
    } else {
      resourceId = resource;
      resourceType = 'Pathway';
    }

    return { resourceId, resourceType };
  }
}
